import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { startLogin } from '../auth/msal';
import { useSession } from '../auth/session';
import { LoginPage } from '../features/login/LoginPage';
import { DEFAULT_PARAMS } from '../features/visits/search';

export const Route = createFileRoute('/login')({ component: LoginRoute });

function LoginRoute(): React.JSX.Element {
  const session = useSession();
  const navigate = useNavigate();
  useEffect(() => {
    if (session.status === 'authenticated' || session.status === 'no-permissions') {
      void navigate({ to: '/', search: DEFAULT_PARAMS });
    }
  }, [session.status, navigate]);
  return <LoginPage onSignIn={startLogin} error={session.loginError} />;
}
